import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import customStyles from "./SelectFeild";

import { signInUser } from "../../Utility/Auth";


const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const CategorySelectByMC = ({ sc = null, mcId = null, handleOnChangeCategory, name = "", scValue = null, placeholder = "Select Sub Category..." }) => {
  const auth = signInUser();
  const { aamarId } = auth;
  let [category, setCategory] = useState([]);
  let [options, setOptions] = useState([]);

  const queryKey = mcId || sc;

  const getCategory = async (key) => {
    try {
      if (key) {
        const result = await axios.get(
          `${BASE_URL}category/mc/${aamarId}/${encodeURIComponent(key)}`
        );
        setCategory(Array.isArray(result.data) ? result.data : []);
      } else {
        const result = await axios.get(`${BASE_URL}category/all/sub/${aamarId}`);
        setCategory(Array.isArray(result.data) ? result.data : []);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategory([]);
    }
  };

  useEffect(() => {
    getCategory(queryKey);
  }, [queryKey, aamarId]);

  useEffect(() => {
    let categories = [];
    if (category.length) {
      category.forEach((vendor) => {
        categories.push({
          option: vendor._id,
          label: `${vendor?.name} - ${vendor.mcId || vendor.code || ""}`,
          mc: vendor.mc,
          group: vendor.group,
        });
      });
    }
    setOptions(categories);
  }, [category]);

  const selectedOption =
    options.find(
      (obj) =>
        String(obj.option) === String(scValue) ||
        (typeof scValue === "object" && scValue?.option && String(obj.option) === String(scValue.option))
    ) || null;

  return (
    <Fragment>
      <Select
        className="basic-single"
        classNamePrefix="select"
        value={selectedOption}
        isDisabled={false}
        isLoading={false}
        isClearable={true}
        isSearchable={true}
        placeholder={placeholder}
        onChange={(selected) => {
          if (handleOnChangeCategory) {
            handleOnChangeCategory(selected || null);
          }
        }}
        name={name}
        options={options}
        styles={customStyles}
      />
    </Fragment>
  );
};

export default CategorySelectByMC;
